<template>
  <div
    v-if="visibleQuickFilters.length"
    class="quick-filters"
  >
    <div class="quick-filters__header">
      <span class="quick-filters__title">Filtros rápidos</span>
      <span class="quick-filters__badge">Novo</span>
    </div>

    <ul class="quick-filters__list">
      <li
        v-for="option in visibleQuickFilters"
        :key="option.label"
      >
        <button
          type="button"
          class="quick-filters__chip"
          :class="{ 'is-active': isActive(option) }"
          @click="toggle(option)"
        >
          <i
            v-if="isActive(option)"
            class="fas fa-check"
          />
          {{ option.label }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import {
  PROPOSAL_QUICK_FILTERS,
  clearProposalQuickFilter,
  isProposalQuickFilterVisible,
} from '@/utils/workerCreditContractManagement';

import roleManagerMixin from '@/mixins/roleManager.mixin';

export default {
  name: 'ProposalQuickFilters',
  mixins: [roleManagerMixin],
  props: {
    isContractManagement: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    storageKey: 'filters',
  }),
  computed: {
    ...mapState({
      filters: (state) => state.proposal.filters,
    }),
    visibleQuickFilters() {
      return PROPOSAL_QUICK_FILTERS.filter((option) => isProposalQuickFilterVisible(option, {
        isCreditor: this.isCreditor,
        isContractManagement: this.isContractManagement,
      }));
    },
  },
  methods: {
    ...mapActions({
      updateFilters: 'proposal/UPDATE_FILTERS',
    }),
    isActive(option) {
      return option.isActive(this.filters);
    },
    toggle(option) {
      const isActive = this.isActive(option);

      this.updateFilters(isActive ? clearProposalQuickFilter() : option.getPatch());
      sessionStorage.removeItem(this.storageKey);
      this.$emit('paginate');
    },
  },
};
</script>

<style lang="scss" scoped>
.quick-filters {
  margin-bottom: 24px;

  &__header {
    display: flex;
    align-items: center;
    gap: .5rem;
    margin-bottom: .75rem;
  }

  &__title {
    font-weight: 700;
    font-size: .75rem;
    letter-spacing: .04em;
    text-transform: uppercase;
  }

  &__badge {
    padding: .125rem .5rem;
    border-radius: 999px;
    background-color: $blue-700;

    font-size: .625rem;
    font-weight: 700;
    letter-spacing: .04em;
    text-transform: uppercase;
    color: #fff;
  }

  &__list {
    display: flex;
    gap: .5rem;
    padding: 0 0 .25rem;
    overflow-x: auto;

    list-style: none;

    li {
      flex-shrink: 0;
    }
  }

  &__chip {
    display: inline-flex;
    align-items: center;
    gap: .375rem;
    padding: .375rem .875rem;
    border: 1px solid $blue-700;
    border-radius: 999px;
    background: transparent;

    font-weight: 600;
    font-size: .875rem;
    color: $blue-700;
    white-space: nowrap;

    cursor: pointer;
    transition: background-color .15s ease, color .15s ease;

    &:hover {
      background-color: rgba($blue-700, .08);
    }

    &.is-active {
      background-color: $blue-700;
      color: #fff;
    }
  }
}
</style>
